import { Check, ArrowRight } from "@phosphor-icons/react";
import { Reveal } from "./Reveal";
import { scrollToId } from "../lib/scroll";

const INCLUDES = [
  "Four monthly Google Business Profile posts",
  "Up to eight review response drafts",
  "Profile information check",
  "Simple monthly performance report",
];

export const MonthlySupport = () => (
  <section
    id="monthly"
    data-testid="monthly-support-section"
    className="py-24 sm:py-32"
  >
    <div className="mx-auto max-w-7xl px-6 sm:px-8 lg:px-12">
      <Reveal>
        <p className="eyebrow mb-5">Monthly Support</p>
        <h2 className="max-w-3xl text-4xl font-extrabold tracking-tight text-ink sm:text-5xl">
          Keep Your Google Profile Fresh Without Adding More to Your To-Do
          List.
        </h2>
      </Reveal>
      <Reveal delay={0.15}>
        <div
          data-testid="monthly-card"
          className="card-surface mt-14 grid grid-cols-1 gap-10 p-8 sm:p-12 lg:grid-cols-12"
        >
          <div className="lg:col-span-4">
            <span className="inline-block rounded-full bg-pine-light px-4 py-1.5 font-heading text-xs font-bold uppercase tracking-[0.15em] text-pine">
              Optional add-on
            </span>
            <div className="mt-6 flex items-end gap-2">
              <span
                data-testid="monthly-price"
                className="font-heading text-6xl font-extrabold tracking-tighter text-ink sm:text-7xl"
              >
                $149
              </span>
              <span className="pb-2.5 font-heading text-sm font-bold uppercase tracking-[0.15em] text-soot">
                /month
              </span>
            </div>
            <p className="mt-4 text-sm text-soot">
              Month-to-month service. No long-term commitment.
            </p>
            <button
              data-testid="monthly-cta-button"
              onClick={() => scrollToId("#audit-form")}
              className="btn-primary mt-8"
            >
              Start With the Free Audit
              <ArrowRight weight="bold" size={18} />
            </button>
          </div>
          <ul className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:col-span-8">
            {INCLUDES.map((item, i) => (
              <li
                key={i}
                className="flex items-start gap-3.5 rounded-3xl bg-cream p-6"
              >
                <span className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-pine">
                  <Check size={15} weight="bold" className="text-cream" />
                </span>
                <span className="font-heading text-lg font-bold leading-snug text-ink">
                  {item}
                </span>
              </li>
            ))}
          </ul>
        </div>
      </Reveal>
    </div>
  </section>
);
